import { Component, inject, signal } from '@angular/core';

import { ButtonComponent } from '../../shared/ui/button/button.component';
import { ThemeToggleComponent } from '../theme/theme-toggle.component';
import { LucideIconComponent } from '../../shared/ui/lucide-icon/lucide-icon.component';
import { AuthService } from '../services/auth.service';
import { Router, RouterModule } from '@angular/router';
import { ToastComponent } from '../../shared/ui/toast/toast.component';

@Component({
  selector: 'app-shell',
  standalone: true,
  imports: [
    RouterModule,
    ButtonComponent,
    ThemeToggleComponent,
    LucideIconComponent,
    ToastComponent
],
  templateUrl: './shell.component.html',
  styleUrls: ['./shell.component.css'],
})
export class ShellComponent {
  auth = inject(AuthService);
  router = inject(Router);
  isMobileMenuOpen = signal(false);
  newDate = new Date();

  toggleMobileMenu(): void {
    this.isMobileMenuOpen.update((isOpen) => !isOpen);
  }

  async logout() {
    await this.auth.logout();
    window.location.href = '/auth/login';
  }

  isPublicRoute() {
    const url = this.router.url;
    return (
      url === '/landing' ||
      url === '/features' ||
      url === '/pricing' ||
      url === '/contact' ||
      url === '/about' ||
      url === '/privacy' ||
      url === '/terms' ||
      url === '/support' ||
      url.startsWith('/auth') ||
      url.startsWith('/accept-invite')
    );
  }
}
